var $,
  wi = $(window).width();

/**
 * Hubspot Form - Show pets number field on check
 *
 * @return {void}
 */
function showPetsNumber () {
  var pets_checkbox = '.checkboxes-pets input:checkbox',
    pets_number_checkbox = '.checkboxes-pets-number',
    hidden = 'hidden';

  $(pets_checkbox).change(function () {
    if (this.checked) {
      $(pets_number_checkbox).removeClass(hidden);

      return;
    }

    $(pets_number_checkbox).addClass(hidden);
  });
}

$(document).ready(function () {
  showPetsNumber();
});
